import script from "./SkillsManReport.vue?vue&type=script&setup=true&lang=js"
export * from "./SkillsManReport.vue?vue&type=script&setup=true&lang=js"

import "./SkillsManReport.vue?vue&type=style&index=0&id=5909b145&lang=scss"

const __exports__ = script;

export default __exports__